import { render, staticRenderFns } from "./myfooter.vue?vue&type=template&id=5b133947&scoped=true&"
import script from "./myfooter.vue?vue&type=script&lang=js&"
export * from "./myfooter.vue?vue&type=script&lang=js&"
import style0 from "./myfooter.vue?vue&type=style&index=0&id=5b133947&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b133947",
  null
  
)

export default component.exports